import { Component } from 'react';
/** Discovery is an optional sibling action; its failure must never remove ordinary Trade. */
export class DirectPurchaseActionBoundary extends Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch() {
        this.props.onFailure();
    }
    render() {
        return this.state.failed ? null : this.props.children;
    }
}
